"use strict";

exports.__esModule = true;
exports.default = void 0;

var _routes = _interopRequireDefault(require("./routes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const config = {
  getDefaultRoutes: _routes.default,
  auth: {
    persistKey: 'base-shell:auth',
    signInURL: '/signin',
    redirectTo: '/'
  }
};
var _default = config;
exports.default = _default;
module.exports = exports.default;